import type { TileLayerConfig } from "./types";

export const precipitationLayerConfig = {
    layerName: "precipitation",
    layerType: "tile",
    dataSources: {
        eu: {
            nearcast: `/maps/combined/precipitation_clouds/ncast/eu/tiles`,
            forecast: `/maps/combined/precipitation_clouds/fcast/status/{latitude}/{longitude}`,
        },
        us: {
            nearcast: `/maps/combined/precipitation_clouds/ncast/us/tiles`,
            forecast: `/maps/combined/precipitation_clouds/fcast/us/tiles`,
        },
    },
    dataSourcesChannels: {
        permanentlyUnavailable: {
            category: 0,
            colorStops: [],
        },
        temporaryUnavailable: {
            category: 1,
            colorStops: [],
        },
        rain: {
            category: 254,
            colorStops: [
                {
                    value: 0,
                    color: [0, 0, 0, 0],
                    treatAsZeroValueStop: true,
                    intensityBarHeightInPercent: 0,
                },
                {
                    value: 1,
                    color: [0, 0, 0, 0],
                    descriptionTranslationKey: "precipitation.none",
                    treatAsZeroValueStop: true,
                    intensityBarHeightInPercent: 0,
                },
                {
                    value: 6,
                    color: [156, 199, 252],
                    descriptionTranslationKey: "precipitation.drizzlePossible",
                    intensityBarHeightInPercent: 15,
                },
                {
                    value: 10,
                    color: [107, 171, 250],
                    descriptionTranslationKey: "precipitation.low",
                    intensityBarHeightInPercent: 30,
                },
                {
                    value: 20,
                    color: [57, 143, 249],
                    descriptionTranslationKey: "precipitation.slightly",
                    intensityBarHeightInPercent: 45,
                },
                {
                    value: 30,
                    color: [6, 92, 197],
                    descriptionTranslationKey: "precipitation.moderate",
                    intensityBarHeightInPercent: 60,
                },
                {
                    value: 38,
                    color: [3, 46, 99],
                    descriptionTranslationKey: "precipitation.moderateToStrong",
                    intensityBarHeightInPercent: 75,
                },
                {
                    value: 42,
                    color: [250, 208, 0],
                    descriptionTranslationKey: "precipitation.strong",
                    intensityBarHeightInPercent: 80,
                },
                {
                    value: 43,
                    color: [251, 165, 102],
                    descriptionTranslationKey: "precipitation.veryStrong",
                    intensityBarHeightInPercent: 85,
                },
                {
                    value: 44,
                    color: [230, 80, 85],
                    descriptionTranslationKey: "precipitation.extreme",
                    intensityBarHeightInPercent: 90,
                },
                {
                    value: 54,
                    color: [184, 64, 80],
                    descriptionTranslationKey:
                        "precipitation.extremeHailPossible",
                    intensityBarHeightInPercent: 100,
                },
            ],
        },
        snow: {
            category: 255,
            colorStops: [
                {
                    value: 0,
                    color: [0, 0, 0, 0],
                    treatAsZeroValueStop: true,
                    intensityBarHeightInPercent: 0,
                },
                {
                    value: 1,
                    color: [0, 0, 0, 0],
                    descriptionTranslationKey: "precipitation.none",
                    treatAsZeroValueStop: true,
                    intensityBarHeightInPercent: 0,
                },
                {
                    value: 6,
                    color: [254, 179, 230],
                    descriptionTranslationKey:
                        "precipitation.drizzlePossibleSnow",
                    intensityBarHeightInPercent: 15,
                },
                {
                    value: 10,
                    color: [254, 154, 222],
                    descriptionTranslationKey: "precipitation.low",
                    intensityBarHeightInPercent: 30,
                },
                {
                    value: 20,
                    color: [244, 138, 211],
                    descriptionTranslationKey: "precipitation.slightly",
                    intensityBarHeightInPercent: 45,
                },
                {
                    value: 30,
                    color: [230, 101, 189],
                    descriptionTranslationKey: "precipitation.moderate",
                    intensityBarHeightInPercent: 60,
                },
                {
                    value: 38,
                    color: [209, 71, 165],
                    descriptionTranslationKey: "precipitation.moderateToStrong",
                    intensityBarHeightInPercent: 75,
                },
                {
                    value: 42,
                    color: [187, 42, 141],
                    descriptionTranslationKey: "precipitation.strong",
                    intensityBarHeightInPercent: 80,
                },
                {
                    value: 43,
                    color: [168, 36, 126],
                    descriptionTranslationKey: "precipitation.veryStrong",
                    intensityBarHeightInPercent: 85,
                },
                {
                    value: 44,
                    color: [152, 27, 112],
                    descriptionTranslationKey: "precipitation.extreme",
                    intensityBarHeightInPercent: 90,
                },
                {
                    value: 54,
                    color: [138, 15, 99],
                    descriptionTranslationKey:
                        "precipitation.extremeHailPossible",
                    intensityBarHeightInPercent: 100,
                },
            ],
        },
    },
} as const satisfies TileLayerConfig;
